module.exports = __webpack_public_path__ + "img/ic_arrow_back_grey_1.fb143fc2.svg";